import { StatesSchema, States } from '@duke-hq/svc-api-db/schemas/enums/States.schema';

// TODO: this hardcodes the app to australia only

export const states: Record<States, string> = {
  [StatesSchema.enum.ACT]: 'Australian Capital Territory',
  [StatesSchema.enum.NSW]: 'New South Wales',
  [StatesSchema.enum.NT]: 'Northern Territory',
  [StatesSchema.enum.QLD]: 'Queensland',
  [StatesSchema.enum.SA]: 'South Australia',
  [StatesSchema.enum.TAS]: 'Tasmania',
  [StatesSchema.enum.VIC]: 'Victoria',
  [StatesSchema.enum.WA]: 'Western Australia',
} as const;

export function getStateKeyByValue(value: string): States | undefined {
  for (const key of Object.values(StatesSchema.enum)) {
    if (states[key] === value) {
      return key;
    }
  }
  return undefined;
}

// TODO: we probably need to source this from an API request to the provider
function getStates(): {
  value: States;
  label: string;
}[] {
  const statesArray: {
    value: States;
    label: string;
  }[] = [];
  for (const key of Object.values(StatesSchema.enum)) {
    statesArray.push({
      value: key,
      label: states[key],
    });
  }
  return statesArray;
}

export const availableStates = getStates();

export function getState(name: string) {
  return availableStates.find((option) => option.label === name);
}
